import React from 'react';
import classes from './styles.module.scss';
import fabbricaLogo from '../../assets/images/fabbrica-milano-cover.svg';

export default () => <img src={fabbricaLogo} className={classes.CoverLogo} alt={'Fabbrica Milano'} />
